import React from 'react';
import { Card } from 'antd';
import { SkBar } from './_primitives';

const StatCard = () => (
  <div className="flex items-center gap-3 min-w-0 p-3 rounded-lg border border-gray-100">
    <div className="w-9 h-9 rounded-lg bg-gray-200 animate-pulse flex-shrink-0" />
    <div className="flex-1 min-w-0 flex flex-col gap-1.5">
      <SkBar h="h-3" w="w-20" />
      <SkBar h="h-4" w="w-6" />
    </div>
  </div>
);

const SideTabs = () => (
  <div className="flex items-center gap-5 px-2 border-b border-gray-200">
    {Array.from({ length: 4 }).map((_, i) => (
      <div
        key={i}
        className={`pb-2 flex-shrink-0 ${i === 0 ? 'border-b-2 border-gray-300' : ''}`}
      >
        <SkBar h="h-3" w="w-12" />
      </div>
    ))}
  </div>
);

const ConversationItem = () => (
  <div className="flex items-start gap-3 py-3 px-2 border-b border-gray-100 last:border-b-0">
    <div className="w-9 h-9 rounded-full bg-gray-200 animate-pulse flex-shrink-0" />
    <div className="flex-1 min-w-0 flex flex-col gap-1.5">
      <div className="flex items-center justify-between gap-2">
        <SkBar h="h-3" w="w-28" />
        <SkBar h="h-2" w="w-10" className="flex-shrink-0" />
      </div>
      <div className="flex items-center gap-2">
        <SkBar h="h-3" w="w-24" />
        <SkBar h="h-4" w="w-14" className="rounded-md" />
      </div>
    </div>
  </div>
);

const EmptyStateCenter = () => (
  <div className="flex-1 flex flex-col items-center justify-center gap-3 px-4">
    <div className="w-14 h-14 rounded-full bg-gray-100 animate-pulse" />
    <SkBar h="h-4" w="w-40" />
    <SkBar h="h-3" w="w-56" />
  </div>
);

const EmptyStateRight = () => (
  <div className="flex-1 flex items-center justify-center px-4">
    <SkBar h="h-3" w="w-36" />
  </div>
);

/**
 * SupportPageLoader — matches Support layout:
 *  top stats bar (5 metrics with icon + label + value) ·
 *  3-column chat shell: conversation list (search + tabs + items) /
 *  empty-state chat area / right info panel.
 */
const SupportPageLoader = () => (
  <div className="w-full p-3 sm:p-4 md:p-6">
    {/* Top stats bar */}
    <Card className="shadow-sm mb-4" styles={{ body: { padding: 12 } }}>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {Array.from({ length: 5 }).map((_, i) => (
          <StatCard key={i} />
        ))}
      </div>
    </Card>

    {/* 3-column chat shell */}
    <div className="grid grid-cols-1 lg:grid-cols-[300px_1fr_280px] gap-4 min-h-[640px]">
      {/* Conversation list */}
      <Card className="shadow-sm" styles={{ body: { padding: 12 } }}>
        <SkBar h="h-10" w="w-full" className="rounded-md mb-3" />
        <SideTabs />
        <div className="mt-2">
          {Array.from({ length: 1 }).map((_, i) => (
            <ConversationItem key={i} />
          ))}
        </div>
      </Card>

      {/* Chat empty state (middle) */}
      <Card className="shadow-sm flex" styles={{ body: { padding: 0, display: 'flex', width: '100%' } }}>
        <EmptyStateCenter />
      </Card>

      {/* Right info panel empty state */}
      <Card className="shadow-sm flex" styles={{ body: { padding: 0, display: 'flex', width: '100%' } }}>
        <EmptyStateRight />
      </Card>
    </div>
  </div>
);

export default SupportPageLoader;
